export const formatNumber = (number: number) => {
    return (number - number % 100).toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
};